import { createSelector } from "reselect";
import {currentUserState} from "views/Auth/Login/selector"
import {appTypeState} from "App/OfflineApp/offlineAppSelectors"
import { activeExperienceIdSelector } from "views/Experiences/ExperienceShow/FirestoreInteractions/selector.js"
// import lodash from "lodash";

const empty = {}

const loadingState = (state, props) => {
  return state.experiences.get("loading");
};
export const experienceLoadingSelector = () =>
  createSelector([loadingState], (loading) => loading);

// const errorState = (state, props) => state.experiences.get("error");

// export const errorSelector = () =>
//   createSelector([errorState], (error) => error);

// const experiencesState = (state, props) =>
//   state.experiences.get("experiences");

// export const experiencesSelector = () =>
//   createSelector([experiencesState], (experiences) => experiences);

// const experiencesShowState = (state, props) => {

//   const experiences = state.experiences.get("experiences");

//   if (experiences.size === 0) {
//     return {};
//   } else {
//     const id = parseInt(props.match.params.id);
//     const idx = lodash.findIndex(experiences, {
//       id: id,
//     });
//     if (idx !== -1) {
//       return experiences[idx];
//     }
//     return {};
//   }
// };

// export const experiencesShowSelector = () =>
//   createSelector([experiencesShowState], (experiences) => experiences);

// const paginationState = (state, props) => {
//   const pageObj = {};
//   pageObj.page = state.experiences.get("page");
//   pageObj.totalPages = state.experiences.get("total_pages");

//   return pageObj;
// };

// export const paginationSelector = () =>
//   createSelector([paginationState], (pageObj) => pageObj);


const experiencesState = (state, props) =>
  state.experiences.get("experiences");

const addCanCurrentUserEdit = (experiences, currentUser) => {
  const finalExperiences = experiences.map((exp) => {
    console.log( "exp", exp, currentUser );
    // add canCurrentUserEdit logic here
    let current_user_can_edit = false
    let current_user_can_monitor = false
    // if(currentUser.role === "superadmin"){
    //   current_user_can_edit = true
    // }
    if(currentUser.role === "qb_author"){
      let allowedQbIds = currentUser.custom_fields["allowed_questionbank_ids"]
      
      if(allowedQbIds && exp.questionbank && allowedQbIds.indexOf(exp.questionbank.id) !== -1){
        current_user_can_edit = true
      }
    }
    else if(currentUser.role === "admin" && exp.org_id === currentUser.org_id){
      current_user_can_edit = true
    }
    else{
      if(exp.experience_memberships_editors && exp.experience_memberships_editors.find(em => em.memberable_id === currentUser.id)){
        current_user_can_edit = true
      }
      if(exp.experience_membership_invigilator_ids && exp.experience_membership_invigilator_ids.indexOf(currentUser.id) > -1){
        current_user_can_monitor = true
      }
    }

    console.log( "exp edited", exp, currentUser );
    
    exp.current_user_can_edit = current_user_can_edit
    exp.current_user_can_monitor = current_user_can_monitor

    return exp;
  })
  return finalExperiences;
  // return experiences;
}

const addCanCurrentUserEditForExperiences = (experiences, currentUser, appType) => {
  // for my assessments, - to not have separate urls and not need makeShowSaga like fns - filtering experiences -
  // this is being used to show exp - not above. above only for lib list i think
  const finalExperiences = []
  if(currentUser.role === "student" || currentUser.role === "parent"){
    // console.log("addCanCurrentUserEditForExperiences appType", appType)
    // if(appType === "seb"){
    //   experiences.forEach((exp) => {
    //     if(exp.settings.mode === "offline"){
    //       finalExperiences.push(exp)
    //     }
    //   })
    //   return finalExperiences
    //   // return experiences.filter(exp => exp.settings.mode == "offline")
    // }
    return experiences
  }else{
    experiences.forEach((exp) => {
      console.log( "exp", exp, currentUser );
      // add canCurrentUserEdit logic here
      let current_user_can_edit = false
      let current_user_can_monitor = false
      let current_user_can_view_in_list = false
      // if(currentUser.role == "superadmin"){
      //   current_user_can_edit = true
      // }
      if(exp.experience_memberships_editors && exp.experience_memberships_editors.find(em => em.memberable_id === currentUser.id)){
        current_user_can_edit = true
        current_user_can_view_in_list = true
      }
      if(exp.experience_membership_invigilator_ids && exp.experience_membership_invigilator_ids.indexOf(currentUser.id) > -1){
        current_user_can_monitor = true
        current_user_can_view_in_list = true
      }
  
      if(currentUser.role === "admin" && exp.org_id === currentUser.org_id){
        current_user_can_edit = true
      }
      if(currentUser.role === "qb_author"){
        let allowedQbIds = currentUser.custom_fields["allowed_questionbank_ids"]
        
        if(allowedQbIds && exp.questionbank && allowedQbIds.indexOf(exp.questionbank.id) !== -1){
          current_user_can_edit = true
        }
      }
  
      console.log( "exp edited", exp, currentUser );
      
      exp.current_user_can_edit = current_user_can_edit
      exp.current_user_can_monitor = current_user_can_monitor
      
      console.log( "finalExperiences current_user_can_view_in_list ", current_user_can_view_in_list );
      if(current_user_can_view_in_list){
        console.log( "finalExperiences push ", exp );
        finalExperiences.push(exp)
      }
      // finalExperiences.push(exp)
      // return exp;
    })
    
  }
  return finalExperiences;
  // return experiences;
}

export const experiencesSelector = () =>
  createSelector([experiencesState, currentUserState, appTypeState], addCanCurrentUserEditForExperiences);

// export const experiencesSelector = () =>
//   createSelector([experiencesState, currentUserState], addCanCurrentUserEdit);

const libraryexperiencesState = (state, props) =>
  state.libraryexperiences.get("experiences");


export const libraryexperiencesSelector = () =>
  createSelector([libraryexperiencesState, currentUserState],addCanCurrentUserEdit);
  
const todayexperiencesState = (state, props) =>
  state.todayexperiences.get("experiences");

export const todayexperiencesSelector = () =>
  createSelector([todayexperiencesState, currentUserState],addCanCurrentUserEdit);

export const activeAdjustedExperienceIdState = (state, props) =>
  state.experiences.get("activeAdjustedExperienceId", null)

export const activeAdjustedExperienceIdSelector = () =>
  createSelector([activeAdjustedExperienceIdState], (activeAdjustedExperienceId) => activeAdjustedExperienceId);

export const activeAdjustedExperienceState = (state, props) => {
  const activeAdjustedExperienceId = activeAdjustedExperienceIdState(state)
  if (!activeAdjustedExperienceId) {
    return {}
  }
  return state.experiences.get("experiences").find((item) => item.id == activeAdjustedExperienceId) || {}
}

export const activeAdjustedExperienceSelector = () =>
  createSelector([activeAdjustedExperienceState], (activeAdjustedExperience) => activeAdjustedExperience);
  // getting not from firebase obj. below one doesn't work if no firebase

export const activeExperienceSelector = (state) => {
  const activeExperienceId = activeExperienceIdSelector(state) 

  if (!activeExperienceId) {
    return {}
  }
  return state.experiences.get("experiences", []).find((item) => item.id == activeExperienceId) || {}; 
}

export const activeExperienceGradingDisabledState = (state, props) => {
  // setting disabled true when mb_linked and rubric_type = myp_achievement_level. We want grading on MB side in this case.
  let gradingDisabled = false
  // // const activeExperience = activeAdjustedExperienceSelector()  // not working when activeAdjustedExperienceSelector is with createSelector
  // const activeExperience = activeAdjustedExperienceState(state) 
  // console.log("activeExperienceGradingDisabledState", activeExperience)
  // if(activeExperience && activeExperience.is_mb_linked && activeExperience.rubric && activeExperience.rubric.type_c === "myp_achievement_level"){
  //   gradingDisabled = true
  // }
  return gradingDisabled
}

export const printExperienceState = (state, props) => 
  state.experiences.get("printExperience", {})

export const printExperienceSelector = () =>
  createSelector([printExperienceState], (printExperience) => printExperience)

export const activeExperienceGradingDisabledSelector = () =>
  createSelector([activeExperienceGradingDisabledState], (activeExperienceGradingDisabled) => activeExperienceGradingDisabled);

export const internetStatusState = (state) =>
  state.experiences.get("internetStatus", 'online');

export const getInternetStatusSelector = () =>
  createSelector([internetStatusState], (internetStatus) => internetStatus);  

export const offlineDBStatusState = (state) =>
  state.experiences.get("offlineDBStatus", 'open');

export const getOfflineDBStatusSelector = () =>
  createSelector([offlineDBStatusState], (offlineDBStatus) => offlineDBStatus); 

export const serverTimeOffsetState = (state) =>
  state.experiences.get("serverTimeOffset", false);

export const getServerTimeOffsetSelector = () =>
  createSelector([serverTimeOffsetState], (serverTimeOffset) => serverTimeOffset); 

export const experienceViewModeState = (state) =>
  state.experiences.get("experienceViewMode", '');

export const experienceViewModeSelector = () =>
  createSelector([experienceViewModeState], (experienceViewMode) => experienceViewMode)

export const exportLoadingState = (state) =>
  state.experiences.get("exportloading", false);

export const exportLoadingSelector = () =>
  createSelector([exportLoadingState], (exportloading) => exportloading);

export const printModeState = (state) =>
  state.experiences.get("printMode", false);

export const printModeSelector = () =>
  createSelector([printModeState], (printMode) => printMode);

export const printOptionsState = (state) =>
  state.experiences.get("printOptions", empty);

export const printOptionsSelector = () =>
  createSelector([printOptionsState], (printOptions) => printOptions);

export const switchFromStartToResumeViewState = (state) =>
  state.experiences.get("switchFromStartToResumeView", true);

export const switchFromStartToResumeViewSelector = () =>
  createSelector([switchFromStartToResumeViewState], (switchFromStartToResumeView) => switchFromStartToResumeView);

export const experienceConfigState = (state) => {
  try {
    return state.experiences.get("experienceConfig", {}).toJS()  // NOTE: Confirm with Abhimanyu why we need toJS for some cases
  } catch (error) {
    return state.experiences.get("experienceConfig", {});
  }
}

export const experienceConfigSelector = () =>
  createSelector([experienceConfigState], (experienceConfig) => experienceConfig);

// export const experienceTypeState = (state) =>
//   state.experiences.get("experienceConfig", {}).experienceType;

export const experienceTypeSelector = () =>
  createSelector([experienceConfigState], (experienceConfig) => experienceConfig.experienceType);

// export const experienceConfigTakeExperienceState = (state) =>
//   state.experiences.get("experienceConfig", {}).takeExperience || {};

export const experienceConfigTakeExperienceSelector = () =>
  createSelector([experienceConfigState], (experienceConfig) => experienceConfig.takeExperience);

// export const experienceMaxEngagementPointsState = (state, props) => {
//   const activeExperience = activeAdjustedExperienceState(state) 
//   const experienceConfigTake = experienceConfigTakeExperienceState(state) 
//   console.log("experienceMaxEngagementPointsState", activeExperience, experienceConfigTake)

//   if (!activeExperience) {
//     return 0
//   }
//   const engagementConfig = experienceConfigTake.engagement

//   console.log("experienceMaxEngagementPointsSelector", engagementConfig, activeExperience);

//   let segmentTypesCount = activeExperience.custom_fields.segment_types_count
//   let maxEngagementPoints = 0

//   if(segmentTypesCount){
//     if(engagementConfig.video.enabled){
//       maxEngagementPoints += segmentTypesCount.video*engagementConfig.video.points
//     }
//     if(engagementConfig.question.enabled){
//       maxEngagementPoints += segmentTypesCount.question*engagementConfig.question.points
//     }
//     if(engagementConfig.game.enabled){
//       maxEngagementPoints += segmentTypesCount.game*engagementConfig.game.points
//     }
//   }

//   return maxEngagementPoints;
// }

export const experienceMaxEngagementPointsSelector = () =>
  createSelector([activeAdjustedExperienceState, experienceConfigState], (activeExperience, experienceConfig) =>  { 
    let experienceConfigTake = experienceConfig.takeExperience

    if (!activeExperience) {
      return 0
    }
    const engagementConfig = experienceConfigTake.engagement
  
    console.log("experienceMaxEngagementPointsSelector", engagementConfig, activeExperience);
  
    let segmentTypesCount = activeExperience.custom_fields && activeExperience.custom_fields.segment_types_count
    let maxEngagementPoints = 0
  
    if(segmentTypesCount){
      if(engagementConfig.video.enabled){
        maxEngagementPoints += segmentTypesCount.video * engagementConfig.video.points
      }
      if(engagementConfig.question.enabled){
        maxEngagementPoints += segmentTypesCount.question * engagementConfig.question.points
      }
      if(engagementConfig.game.enabled){
        maxEngagementPoints += segmentTypesCount.game * engagementConfig.game.points
      }
    }

    return maxEngagementPoints
  });

const experienceAnalyticsSummaryState = (state, props) =>
  state.experiences.get("experienceAnalyticsSummary", { max: {}, average: {}, min: {}, median: {} });

export const experienceAnalyticsSummarySelector = () =>
  createSelector([experienceAnalyticsSummaryState], (experienceAnalyticsSummary) => experienceAnalyticsSummary);

const experienceAnalyticsQuestionsState = (state, props) =>
  state.experiences.get("experienceAnalyticsQuestions", {});

export const experienceAnalyticsQuestionsSelector = () =>
  createSelector([experienceAnalyticsQuestionsState], (experienceAnalyticsQuestions) => experienceAnalyticsQuestions);

const experienceAnalyticsTagsState = (state, props) =>
  state.experiences.get("experienceAnalyticsTags", {});

export const experienceAnalyticsTagsSelector = () =>
  createSelector([experienceAnalyticsTagsState], (experienceAnalyticsTags) => experienceAnalyticsTags);

const gradebookAnalyticsState = (state, props) =>
  state.experiences.get("gradebookAnalytics", {});

export const gradebookAnalyticsSelector = () =>
  createSelector([gradebookAnalyticsState], (gradebookAnalytics) => gradebookAnalytics);

export const monitorConfigState = (state) =>
  state.experiences.get("monitorConfig", {});

export const monitorConfigSelector = () =>
  createSelector([monitorConfigState], (monitorConfig) => monitorConfig);

export const calcTypeState = (state) =>
  state.experiences.get("calcType", "desmos_scientific_calc");

export const calcTypeSelector = () =>
  createSelector([calcTypeState], (calcType) => calcType);
